import { surroundPlaceholders } from '@emartech/personalization-twig-token';
import { CustomElement } from '../../../../lib/custom-element-decorators';
import {
  CodeEditorToolbarContext,
  ToolbarItemEvents,
  CodeEditorToolbarPersonalizationPrompt,
  CodeEditorToolbarPersonalizationPromptInputs,
} from '../../interface';
import { HTMLCustomElement, ReactiveAttribute } from '../../../../lib/index';
import { combineLatest, Observable } from 'rxjs';
import { Callback } from '../../../../lib/reactive-decorators';
import { takeUntil, take, skip, map, startWith } from 'rxjs/operators';

export const createCodeEditorToolbarPersonalizationPrompt = (global: { prompt: any }) => {
  class CodeEditorToolbarPersonalizationPromptImplementation
    extends HTMLCustomElement
    implements CodeEditorToolbarPersonalizationPrompt
  {
    @Callback('disconnectedCallback') private _disconnect$: Observable<void>;
    @ReactiveAttribute('label', 'label')
    private _label$: Observable<string>;
    @ReactiveAttribute('icon', 'icon')
    private _icon$: Observable<string>;
    private _inputs: CodeEditorToolbarPersonalizationPromptInputs;

    connectedCallback(): void {
      this._inputs$.subscribe(input => (this._inputs = input));
      this._inputs$.pipe(take(1)).subscribe(() => {
        this.dispatchEvent(new CustomEvent(ToolbarItemEvents.Connected, { bubbles: true }));
      });
      this._inputs$.pipe(skip(1)).subscribe(() => {
        this.dispatchEvent(new CustomEvent(ToolbarItemEvents.Updated, { bubbles: true }));
      });
    }

    disconnectedCallback(): void {
      this.dispatchEvent(new CustomEvent(ToolbarItemEvents.Disconnected));
    }

    getItem(context: CodeEditorToolbarContext): HTMLElement {
      const tooltip = this._createTooltip();
      const icon = this._createIcon(this._inputs.icon);
      const button = this._createButton();

      button.onclick = () => this._openDialog(context);
      button.appendChild(icon);
      tooltip.appendChild(button);
      return tooltip;
    }

    private _createTooltip(): HTMLElement {
      const tooltip = document.createElement('e-tooltip');
      tooltip.setAttribute('content', this._inputs.label);
      return tooltip;
    }

    private _createButton(): HTMLElement {
      const button = document.createElement('div');
      button.className = 'e-btn e-btn-onlyicon e-inputgroup__item';
      return button;
    }

    private _createIcon(iconName: string): HTMLElement {
      const icon = document.createElement('e-icon');
      icon.setAttribute('icon', iconName);
      return icon;
    }

    private _openDialog(context: CodeEditorToolbarContext): void {
      const tokenName = global.prompt('Token name:');
      const preview = global.prompt('Preview:');

      if (tokenName !== null && preview !== null) {
        context.insertText(surroundPlaceholders(preview, { tokenName, preview }));
      }
    }

    get _inputs$(): Observable<CodeEditorToolbarPersonalizationPromptInputs> {
      return combineLatest(this._label$, this._icon$.pipe(startWith('e-profile'))).pipe(
        takeUntil(this._disconnect$),
        map(([label, icon]) => ({ label, icon })),
      );
    }
  }

  return CodeEditorToolbarPersonalizationPromptImplementation;
};

const name = 'vce-code-editor-toolbar-personalization-prompt';
CustomElement(name)(createCodeEditorToolbarPersonalizationPrompt(window as any));
